module.exports = __webpack_public_path__ + "img/empty-state.6819d42e.svg";